import React from "react";
import { ArrowRightIcon } from "lucide-react";
import type { Answer } from "../../types/content";
import { SiteLink } from "../SiteLink";
type AnswerSectionProps = Answer & {
  headingLevel?: "h2" | "h3";
};

/**
 * Reusable question-and-answer block for the homepage and subpages.
 * The answer is always visible text. Author / reviewer / updated date render
 * only when supplied from an approved source — never as defaults.
 */
export function AnswerSection({
  id,
  question,
  answer,
  link,
  meta,
  headingLevel = "h3"
}: AnswerSectionProps) {
  const Heading = headingLevel;
  const headingId = `answer-${id}`;
  const metaItems = [meta?.author ? `Written by ${meta.author}` : null, meta?.reviewer ? `Reviewed by ${meta.reviewer}` : null, meta?.updated ? `Updated ${meta.updated}` : null].filter((item): item is string => Boolean(item));
  return <article aria-labelledby={headingId} className="grid gap-3 py-6 md:py-7 lg:grid-cols-12 lg:gap-16" data-id="element-1" data-mp="2amzu7wiesv3p">
      <Heading id={headingId} className="text-h3 font-bold text-ink lg:col-span-5" data-id="element-2" data-mp="k3737zad2dd">
        {question}
      </Heading>
      <div className="lg:col-span-7" data-id="element-3" data-mp="3rpulja3paqkc">
        <p className="max-w-measure text-ink" data-id="element-4" data-mp="3rqw6q7efktfs">{answer}</p>
        {metaItems.length > 0 && <p className="mt-4 text-meta text-slate" data-id="element-5" data-mp="3my33jnym1t5t">{metaItems.join(" · ")}</p>}
        {link && <SiteLink path={link.path} className="mt-4 inline-flex min-h-[48px] items-center gap-2 text-label font-bold text-crimson underline underline-offset-4 hover:text-crimson-deep" data-id="element-6" data-mp="3i01iixhmjjrp">
            {link.label}
            <ArrowRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-7" data-mp="340jpg5xapkcj" />
          </SiteLink>}
      </div>
    </article>;
}